import React from "react";
import { Handle, Position } from '@xyflow/react';
import { formatDateTime, calculateStartTime } from '../utils/time';

const isMobile = () => window.innerWidth <= 600;

function formatCompactTime(seconds) {
    if (!seconds || seconds <= 0) return null;
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    if (h > 0 && m > 0) return `${h}h${m}m`;
    if (h > 0) return `${h}h`;
    return `${m}m`;
}

export function StepNode({ id, data }) {
    const { label, description, preparationTime, waitingTime, ingredients = [],
            prepSeconds, waitSeconds, color = 'green',
            globalEndTime, timeUntilEnd, isExpanded, onToggleExpand } = data;
    const startTime = globalEndTime ? calculateStartTime(globalEndTime, timeUntilEnd) : undefined;
    const mobile = isMobile();

    const prepStr = formatCompactTime(prepSeconds);
    const waitStr = formatCompactTime(waitSeconds);
    const timeParts = [];
    if (prepStr) timeParts.push(prepStr + ' prep');
    if (waitStr) timeParts.push(waitStr + ' wait');
    const timeLabel = timeParts.join(' \u00b7 ');

    return (
        <div
            className={`react-flow-node compact node-${color}${isExpanded ? ' expanded' : ''}`}
            style={{ width: mobile ? '160px' : '220px' }}
            onClick={() => onToggleExpand && onToggleExpand(isExpanded ? null : id)}
        >
            <Handle id="top" type="target" position={Position.Top} />
            <Handle id="left" type="target" position={Position.Left} />
            <Handle id="right" type="target" position={Position.Right} />
            <div className="node-header">
                <div className="node-header-text">
                    <span className="node-title">{label}</span>
                    {timeLabel && (
                        <span className="node-time">{timeLabel}</span>
                    )}
                </div>
                <span className="node-expand-icon">{isExpanded ? '\u25be' : '\u25b8'}</span>
            </div>

            {isExpanded && (
                <div className="node-details">
                    {description && (
                        <p className="node-description">{description}</p>
                    )}
                    <div className="node-content">
                        <strong>Prep:</strong> {preparationTime}
                    </div>
                    {waitingTime && (
                        <div className="node-content">
                            <strong>Wait:</strong> {waitingTime}
                        </div>
                    )}
                    {startTime && (
                        <div className="node-content">
                            <strong>Start:</strong> {formatDateTime(startTime)}
                        </div>
                    )}
                    {ingredients.length > 0 && (
                        <div className="node-ingredients">
                            <strong>Ingredients ({ingredients.length}):</strong>
                            <ul>
                                {ingredients.map((ing, index) => (
                                    <li key={index}>{ing.amount} {ing.unit} {ing.name}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            )}
            <Handle id="bottom" type="source" position={Position.Bottom} />
        </div>
    );
}

export const nodeTypes = {
    stepNode: StepNode,
};
